export default defineNuxtRouteMiddleware(async (to) => {
    // const localePath = useLocalePath();
    const teamIndexPage = `/admin/${to.params.team}`;
    const productIndexPage = `${teamIndexPage}/${to.params.product}`;

    const { user } = useUserSession();

    const productAccess = user.value.productAccess;

    // Redirect to upgrade page if the product test has expired
    if (productAccess[to.params.product]?.testPeriod?.isExpired) {
        return navigateTo(`${productIndexPage}/upgrade`);
    }
    const {
        manageableProducts,
        canManageProducts,
        checkProductManagementAccess,
    } = useUserPermissions();
    if (to.path === teamIndexPage && canManageProducts.value) {
        await navigateTo(`${teamIndexPage}/${manageableProducts[0]}`);
        return;
    }

    if (
        checkProductManagementAccess(to.params.product) &&
        to.path === productIndexPage
    ) {
        await navigateTo(`${productIndexPage}/dashboard`);
        return;
    }

    if (
        !checkProductManagementAccess(to.params.product) &&
        to.path !== productIndexPage
    ) {
        await navigateTo(teamIndexPage);
        return;
    }
});
